// eslint-disable-next-line import/prefer-default-export
import pageTitleMessages from "./pageTitleMessages";
import feedbackModalsMessages from "./feedbackModalsMessages";
import hegMappingMessages from "./hegMappingMessages";
import toastMessages from "./toastMessages";
import tableHeaderMessages from "./tableHeaders";
import tBuilderValidationMessages from "./tBuilderValidationMessages";

const intlMessagesCs = {
  "common.app": "FLOWIO",
  "common.advanced": "Pokročilé",
  "common.show_all": "Zobrazit vše",
  "common.delete": "Smazat",
  "common.edit": "Upravit",
  "common.password": "Heslo",
  "common.login": "Přihlásit se",
  "common.favourite": "Oblíbené",
  "common.favourite_templates": "Oblíbené šablony",
  "common.yes": "Ano",
  "common.no": "Ne",
  "common.reload": "Aktualizovat",
  "common.send": "Odeslat",
  "common.change": "Změnit",
  "common.insert": "Vložit",
  "common.close": "Zavřít",
  "common.back": "Zpět",
  "common.default": "Výchozí",
  "common.detail": "Detail",
  "common.search": "Hledat",
  "common.save": "Uložit",
  "common.new": "Nový",
  "common.copy": "Kopírovat",
  "common.find": "Hledat",
  "common.loading": "Načítá se...",
  "common.empty_list": "Tento seznam neobsahuje žádné položky",
  "common.accept": "Potvrdit",
  "common.decline": "Zrušit",
  "common.invalid_value": "Neplatná hodnota",
  "common.select_all": "Označit vše",
  "common.unselect_all": "Odznačit vše",
  "common.fulltext.search": "Zadejte hledaný text..",
  "common.advanced.search": "Pokročilé vyhledávání",
  "common.icon": "Ikona",
  "common.and_x_more": "Zobrazit {x} dalších",
  "common.show_less": "Zobrazit méně",
  "common.chose": "Vybrat",
  "common.run": "Spustit",
  "common.reset": "Resetovat",
  "common.active": "Aktivní",
  "common.update": "Obnovit",
  "common.add": "Přidat",
  "common.filter": "Filtr",
  "common.filters": "Filtry",
  "common.more": "Více",
  "common.less": "Méně",
  "common.undo": "Vrátit",
  "common.order": "Pořadí",
  "common.translation": "Překlad",
  "common.import": "Importovat",
  "common.resolved": "Vyřešený",
  "common.unresolved": "Nevyřešený",
  "confirmation.confirmAction": "Potvrdit akci",

  "error_boundary.something_went_wrong": "Něco se pokazilo",
  "error_boundary.rerender": "Znovu načíst",
  "error_boundary.go_to_homepage": "Jít na domovskou stránku",

  "common.information": "Informace",
  "common.tables": "Tabulky",
  "common.modules": "Moduly",
  "common.templates": "Šablony",
  "common.import_templates": "Import šablon",
  "common.diagnostic": "Diagnostika",
  "common.notifications": "Notifikace",
  "common.functions": "Funkce",
  "common.data_source": "Datový zdroj",
  "common.datasources": "Datové zdroje",
  "common.user": "Uživatel",
  "common.users": "Uživatelé",
  "common.roles": "Role",
  "common.personalization": "Přizpůsobení",
  "common.model": "Model",
  "common.enter_text": "Zadejte text",
  "common.no_options": "Žádné možnosti",
  "common.save_for_all_users": "Pro všechny uživatele:",
  "home.welcome": "Vítejte v systému ",
  "home.about":
    "FLOWIO Vám umožňuje zpracovat docházku, mít přehled o stavu technické údržby, řešit nákup přes centrální nákup a mít pod kontrolou náklady",
  "home.favourite_templates": "Oblíbené šablony",
  "home.modules": "Moduly",
  "home.modules.title": "Popis šablony",
  "common.name": "Název",
  "common.error": "Chyba",
  "common.warning": "Varování",

  "table.scheme.short": "Schéma",
  "table.schema.update": "Aktualizovat schéma",
  "table.schema.update.error":
    "Při aktualizaci schématu tabulky došlo k chybě.",
  "table.columns": "Sloupce",
  "table.columns.tooltip": "Tabulka obsahuje všechny sloupce",
  "table.columns.missing.table": "Chybějící tabulka",
  "table.columns.missing": "Chybějící sloupec",
  "table.columns.missing.tooltip": "Tabulce chybí nějaké sloupce",
  "table.add": "Přidat tabulku",
  "table.row.edit": "Upravit detail řádku",
  "table.row.inline_edit": "Upravit řádek",
  "table.row.inline_copy": "Kopírovat řádek",
  "table.row.previous": "Předchozí záznam",
  "table.row.next": "Další záznam",
  "table.row.copy_row": "Kopírovat detail řádku",
  "table.name": "Jméno tabulky",
  "table.scheme": "Schéma tabulky",
  "table.reset_scheme": "Resetovat schéma",
  "table.data": "Data tabulky",
  "table.data.value": "Data tabulky: {value}",
  "table.row.insert": "Nový záznam",
  "table.row.copy": "Kopírovat záznam",
  "table.row.add": "Přidat záznam",
  "table.row.add.detail": "Přidat záznam podle detailu",
  "table.user_filter": " Uživatelský filtr",
  "table.detail": "Detail záznamu",
  "table.data_source_id": "Datový zdroj",
  "table.no_rows": "Nejsou k zobrazení žádná data",
  "table.no_position_data.mobile_table":
    "Pro zobrazení této šablony na mobilu musí administrátor nejprve nastavit mobilní rozložení buněk v přehledové šabloně",
  "table.no_position_data.detail":
    "Pro zobrazení tohoto detailu musí administrátor nejprve nastavit rozložení buněk v detailové šabloně",
  "table.more_entries": "Více záznamů ({entries})",
  "table.add_entry": "Přidat záznam",
  "table.chose_item": "Vybrat položku",
  "table.export_table": "Exportovat tabulku",
  "table.export_table.modal": "Exportovat šablonu {templateName}",
  "table.export_table.success":
    "Šablona byla úspěšně transformována do požadovaného formátu a uložena na Vašem zařízení.",
  "table.export_table.table_name": "Název souboru",
  "table.export_table.table_extension": "Typ souboru",
  "table.export_table.number_of_pages":
    "Počet stránek k exportu (1-{numberOfPages})",
  "table.export_table.only_one_page": "Počet stránek k exportu (1)",
  "table.export_table.export_all_pages": "Exportovat všechny stránky",
  "table.export_table.error.number_of_pages": "Nesprávný počet stránek",
  "table.export_table.options": "Možnosti exportu",
  "table.export_table.options.table": "Pouze tabulku",
  "table.export_table.options.detail": "Pouze hlavičku",
  "table.export_table.options.table_and_detail": "Hlavičku i tabulku",
  "table.export_table.columns_visibility": "Zobrazení sloupců tabulky",
  "table.export_table.columns_visibility.settings":
    "Nastavení zobrazení sloupců tabulky",
  "table.detail.save.error": "Chyba při ukládání detailu",
  "table.detail.create.success": "Záznam byl úspěšně vytvořen",
  "table.overview.error": "Chyba při získávání tabulek pro výběry z přehledu",
  "table.row.revalidation.error": "Chyba při revalidaci řádku",
  "table.paging.info": "Záznamy {from} až {to} z {totalRowCount}",

  "file_dropzone.label":
    "Soubory můžete přiložit kliknutím/vložením ze schránky/přetažením zde",
  "file_dropzone.accepted_types": "Akceptované typy souborů: {types}",
  "file_dropzone.image_and_pdf": "Obrázky a PDF",

  "data_sources.add_source": "Přidat zdroj",
  "data_sources.name": "Název",
  "data_sources.server": "Server",
  "data_sources.database": "Databáze",
  "data_sources.url": "URL",
  "data_sources.url_domain": "Domain URL",
  "data_sources.url_google": "Google URL",
  "data_sources.profile": "Profil",
  "data_sources.type": "Typ",
  "data_sources.state": "Stav",
  "data_sources.login": "Login",
  "data_sources.password": "Heslo",
  "data_sources.maxConcurrentConnections": "Počet souběžných připojení: ",
  "data_sources.mapping_type": "Typ mapování",
  "data_sources.mapping_type.basic": "Základní",
  "data_sources.mapping_type.user": "Uživatel",
  "data_sources.mapping_type.servis_account": "Servisní účet",
  "data_sources.mapping_type.servis_account_and_user":
    "Uživatel a Servisní účet",
  "data_sources.mapping.domain": "Doménové mapování",
  "data_sources.mapping.not_domain": "Nedoménové mapování",
  "data_sources.mapping.google": "Google mapování",
  "data_sources.login_type": "Typ přihlášení",
  "data_sources.login_type.user": "Jméno a heslo",
  "data_sources.login_type.domain": "Doména",
  "data_sources.login_type.google": "Google",

  "data_sources.mapping.error.login_type":
    "Datový zdroj musí mít nastavené alespoň jedno mapování pro uživatele a jedno pro servisní účet",

  "data_sources.mapping.error.url": "Typ mapování musí mít přiřazenou URL",

  "data_sources.map_default_user": "Namapovat",
  "data_sources.unmap_default_user": "Odmapovat",
  "data_sources.default_user_mapping": "Výchozí mapování",
  "data_sources.allow_heg_sql_functions": "Heg sql funkce",
  "data_sources.insert_disabled_info":
    "Mapování výchozího uživatele bude možné až po vložení záznamu.",
  "data_sources.reset_column_schema": "Resetovat scháma sloupce",
  "data_sources.reset_column_schema.success": "Schéma sloupce bylo obnoveno",
  "data_sources.reset_column_schema.error": "Chyba při resetování schématu",
  "data_source.time_zones": "Časová zóna",
  "data_source.time_zones.fetch.error": "Chyba při získávání časových zón",

  "modules.add_module": "Přidat modul",
  "modules.name": "Název",
  "modules.visible": "Viditelný",
  "modules.description": "Popis",
  "modules.picture": "Obrázek",
  "modules.add_picture": "Přiřadit obrázek",
  "modules.no_roles": "Tento modul nemá přiřazenou žádnou roli",
  "modules.sort.modules": "Seřadit moduly",
  "modules.sort.templates": "Seřadit šablony z modulu {moduleName}",
  "modules.sort.modules.modal": "Řazení modulů",
  "modules.sort.templates.modal": "Řazení šablon pro modul {moduleName}",

  "roles.add_role": "Přidat roli",
  "roles.add_roles": "Přiřadit role",
  "roles.name": "Název role",
  "roles.type": "Typ role",
  "roles.search": "Hledat role...",
  "roles.guest": "Host",
  "roles.editor": "Editor",

  "templates.add_template": "Přidat šablonu",
  "templates.add_templates": "Přidat šablony",
  "templates.create_template": "Vytvořit šablonu",
  "templates.overview": "Přehled",
  "templates.detail": "Detail",
  "templates.item": "Položková",
  "templates.multi": "Více-zdrojová",
  "templates.multi_detail": "Vícezdrojový detail",
  "templates.hwrAdaptionPlan": "Adaptační plán",
  "templates.hwrAnnualEval": "Roční vyhodnocení",
  "templates.hwrPersonalDevPlan": "Plán osobního rozvoje",
  "templates.hwrPotentialEval": "Hodnocení potenciálu",
  "templates.name": "Název",
  "templates.table": "Tabulka",
  "templates.device": "Zařízení",
  "templates.visible": "Viditelná",
  "templates.displayAs": "Zobrazit jako",
  "templates.module": "Modul",
  "templates.type": "Typ",
  "templates.notification": "Notifikační",
  "templates.calendar": "Kalendář",
  "templates.system": "Systém",
  "templates.SSRS": "SSRS",
  "templates.search": "Hledat šablony",
  "templates.import": "Importovat šablonu",
  "templates.Id": "Id",
  "templates.description": "Popis",
  "templates.order": "Pořadí",
  "templates.info": "Popis šablony",
  "templates.imported": "Importována",
  "templates.created": "Ze dne",

  "templates.device.type.web": "Web",
  "templates.device.type.webAndMobile": "Web i mobil",
  "templates.device.type.mobile": "Mobil",
  "templates.device.modal.title":
    "Chcete změnit typ zařízení i na všechny související šablony?",
  "templates.device.modal.message":
    "Související šablony jsou všechny detailové a položkové šablony, které jsou na této šabloně. Pokud si to nebudete přát, tak typ zařízení bude změněn pouze aktuální šabloně.",

  "templates.export.title": "Exportovat šablonu",
  "templates.export.label": "Exportovaná šablona",
  "templates.export.modal.title": "Export šablony {templateName}",
  "templates.export.modal.message":
    "Chcete exportovat i všechny související šablony?",
  "templates.export.modal.post_message":
    "Související šablony jsou všechny detailové a položkové šablony, které jsou na této šabloně. Pokud si to nebudete přát, tak bude exportována pouze šablona {templateName}",
  "templates.export.error":
    "Při exportu šablony {templateName} došlo k chybě. Zkuste to prosím znovu nebo kontaktujte administrátora.",

  "templates.import.modal.title": "Import šablony",
  "templates.import.modal.missing_file":
    "Pro import šablony je nutné nahrát soubor s exportovanou šablonou ve formátu JSON",
  "templates.import.modal.success": "Šablona byla úspěšně importována.",
  "templates.import.modal.partial_success":
    "Import šablony byl úspěšně nahrán na server. Aby byla šablona úspěšně importována, je potřeba vyřešit importy dceřiných šablon. Počet dceřiných šablon k vyřešení je {templatesCount}.",
  "templates.import.modal.error": "Při importu šablony došlo k chybě.",
  "templates.import.delete.success":
    "Import {importName} byl úspěšně odstraněn.",
  "templates.import.delete.error":
    "Při odstraňování importu {importName} došlo k chybě.",
  "templates.import.delete": "Smazat import",
  "templates.import.empty": "Nemáte žádné rozdělané importy",
  "templates.import.success": "Import šablony/šablon proběhl úspěšně.",
  "templates.import.error":
    "Při importu šablony/šablon došlo k chybě. Kontaktujte administrátora.",
  "templates.import.template": "Importovat šablonu",
  "templates.import.templates": "Importovat šablony",
  "templates.import.update": "Import šablony byl aktualizován",

  "templates.import.refresh": "Aktualizovat importy",
  "templates.import.table.isValid": "Validní",
  "templates.import.table.isExist": "Existuje",
  "templates.import.table.state": "Stav",
  "templates.import.table.state.original": "Původní",
  "templates.import.table.state.updated": "Aktualizovaný",
  "templates.import.table.state.imported": "Importovaný",
  "templates.import.table.state.notImported": "Neimportovaný",
  "templates.import.table.select": "Namapovat tabulku",
  "templates.import.table.select.modal": "Mapování tabulky na tabulku {name}",
  "templates.import.table.dataSource":
    "Tabulky z datového zdroje: {dataSourceName}",

  "templates.import.function.select": "Namapovat funkci",
  "templates.import.function.select.modal": "Mapování funkce na funkci {name}",
  "templates.import.function.dataSource":
    "Funkce z datového zdroje: {dataSourceName}",
  "templates.import.function.new_id": "Nové Id",
  "templates.import.function.empty":
    "Importovaná šablona neobsahuje žádné funkce",

  "templates.import.heg.classes_and_folders": "HeG třídy a soubory",

  "templates.import.overview.id": "Id importu",
  "templates.import.overview.count": "Počet šablon k vyřešení",
  "templates.import.overview.export_date": "Datum exportu",
  "templates.import.overview.export_user": "Exportováno uživatelem",
  "templates.import.overview.import_date": "Datum importu",
  "templates.import.overview.import_user": "Importováno uživatelem",

  "templates.import.detail": "Přejít na detail",
  "templates.import.detail.error":
    "Nastala chyba při získávání detailu importu.",
  "templates.import.detail.validate": "Zkontrolovat import",
  "templates.import.detail.refresh": "Aktualizovat import",

  report_a_bug: "Nahlásit chybu v aplikaci",
  send_feedback: "Odeslat zpětnou vazbu",

  "bugs_overview.modal.title": "Přehled chyb v aplikaci",
  "bugs_overview.modal.report": "Nahlásit",
  "bugs_overview.modal.remove": "Odstranit",
  "bugs_overview.modal.reported": "Chyba byla nahlášena",

  "functions.title": "Funkce",
  "functions.select_function": "Vyberte funkci",
  "functions.add_function": "Přidat funkci",
  "functions.add_functions": "Přidat funkce",
  "functions.edit_functions": "Upravit funkce",
  "functions.name": "Název",
  "functions.type": "Typ",
  "functions.isCommon": "Je obecná",
  "functions.id": "Id",
  "functions.column": "Sloupec",
  "functions.item_based": "Položková",
  "functions.parent_column": "Sloupec rodiče",
  "functions.skipRecordsOnError": "Přeskočit záznamy s chybou",
  "functions.params": "Parametry funkce {name}",
  "functions.run": "Spustit funkci",
  "functions.datasource": "Datový zdroj",
  "functions.parametersJSON": "Parametry",
  "functions.database": "Databázová",
  "functions.function_id": "Id funkce",
  "functions.search": "Hledat funkce",
  "functions.function_without_template": "Funkce bez šablony ({name})",
  "functions.empty_list": "Nad vybranými záznamy nelze spustit žádnou funkci",
  "functions.run_confirm_message": "Chcete spustit funkci ",
  "functions.workflow_comment": "Komentář ke spuštění funkce",
  "functions.workflow_comment.placeholder.mandatory":
    "Zadejte komentář (povinné)",
  "functions.workflow_comment.placeholder.optional":
    "Zadejte komentář (nepovinné)",

  "functions.workflow_comment.type": "Komentář při spuštění",
  "functions.workflow_comment.type.none": "Žádný",
  "functions.workflow_comment.type.required": "Povinný",
  "functions.workflow_comment.type.optional": "Volitelný",

  "common.common": "Obecná",

  "function.import_function": "Importovat funkci",
  "function.parameters.show": "Zobrazit parametry",
  "function.parameters.hide": "Skrýt parametry",
  "function.parameters.modal.title": "Detail parametru {name}",
  "function.parameters.add": "Přidat parametry",
  "function.parameters.save": "Uložit parametry",
  "function.parameters.edit_filer": "Editovat relativní filtr",

  "function.run.success": "Funkce byla úspěšně spuštěna",
  "function.run.error": "Chyba při spouštění funkce",
  "function.run.warning": "Chyba při spouštění funkce",
  "function.delete.message":
    "Funkce kterou chcete smazat se objevuje na následujících šablonách. Doopravdy chcete pokračovat a funkci smazat?",
  "function.delete.message.p.m":
    "Funkce bude smazána i ze šablon zmíněných výše.",
  "function.delete.templates.overview": "Přehled šablon s výskytem funkce",
  "function.delete.templates.active": "Aktivní šablony",
  "function.delete.templates.deleted": "Smazané šablony",

  "administration.title": "Administrace",
  "administration.info":
    "Přístup do administrace má pouze uživatel s rolí Administrator",
  "administration.tables":
    "<strong>Tabulky </strong>slouží k vybrání tabulek z datové databáze nad kterými bude možné vytvářet šablony.",
  "administration.modules":
    "<strong>Moduly </strong>jsou zobrazovány na hlavní straně a sdružují pod sebou  šablony. Musejí mít přiřazeny role - uživatelé v dané roli boudou mít do modulu přístup.",
  "administration.templates":
    "<strong>Šablony </strong>definují model podle kterého budou zobrazována data z vybrané tabulky. Lze vybírat mezi přehledovou a detailovou šablonou. Přehledová šablona může pod sebe zahrnout jinou detailovou šablonu. Musejí mít přiřazeny role - uživatelé budou mít k šabloně přístup a budou moci editovat/prohlížet data podle typu role.",
  "administration.data_source":
    "<strong>Datové zdroje </strong>slouží k definici jednotlivých databázových připojení. Nové záznamy přidává administrátor.",
  "administration.users":
    "<strong>Uživatelé </strong>jednotliví uživatelé aplikace. Musejí být přiřazeni k rolím. Nové uživatele přidává administrátor.",
  "administration.roles":
    "<strong>Role </strong>sdružují pod sebe uživatele a dávají jim práva zobrazit moduly a šablony. Jsou rozděleny na 2 typy - Host a Editor. Host má právo pouze prohlížet data a Editor je může i upravovat (mazat, přidávat, upravovat).",
  "administration.personalization":
    "<strong>Přizpůsobení </strong>umožní uživateli změnit vzhled aplikace. Tím se rozumí pozadí, barvy tlačítek a nadpisů, obrázky, názvy a další.",
  "administration.image": "Ikona",
  "administration.template_versions": "Verze šablony",
  "administration.template_versions.current_version": "Verze",
  "administration.template_versions.apply": "Aplikovat verzi šablony",
  "administration.nav.template_builder": "Model šablony {templateId}",
  "administration.nav.settings": "Nastavení šablony",
  "administration.nav.data_model": "Datový model",
  "administration.nav.presentation_model": "Prezentační model",
  "administration.nav.overview": "Zobrazit přehled",

  "localization.label": "Jazyk",
  "localization.czech": "Čeština",
  "localization.english": "English",

  "localization.cs": "Česky",
  "localization.en": "Anglicky",

  "settings.personal_settings": "Osobní nastavení",
  "settings.personal.name": "Jméno",
  "settings.personal.surname": "Příjmení",
  "settings.personal.email": "Email",
  "settings.personal.birth": "Datum narození",
  "settings.dashboard_settings": "Nastavení dashboardu",
  "settings.app_settings": "Nastavení aplikace",
  "settings.template_entries": "Defaultní počet záznamů na šablonách",

  "warning.error": "Chyba",
  "warning.required": "Toto pole je povinné",
  "warning.user_name_already_existing": "Uživatelské jméno již existuje",
  "warning.login_name_already_existing": "Přihlašovací jméno již exituje",
  "warning.short_password": "Heslo musí obsahovat alespoň 6 znaků",
  "warning.passwords_dont_match": "Hesla se neshodují",
  "warning.not_an_email": "Nesprávně zadaný email",
  "warning.no_filled_email": "Uživatel nemá vyplněný email",

  "registration.registration": "Registrovat se",
  "registration.new_user": "Nový uživatel",
  "registration.user_name": "Jméno a příjmení :",
  "registration.user_name.no_dots": "Uživatelské jméno",
  "registration.login_name.no_dots": "Přihlašovací jméno",
  "registration.login_name": "Přihlašovací jméno:",
  "registration.password": "Heslo:",
  "registration.password_again": "Heslo znovu:",
  "registration.old_password": "Staré heslo:",
  "registration.new_password": "Nové heslo:",
  "registration.new_password_again": "Nové heslo znovu:",
  "registration.email_address": "Email:",
  "registration.deactivated": "Deaktivován",
  "registration.deactivate": "Deaktivovat",
  "registration.deactivation_date": "Datum deaktivace",
  "registration.activate": "Aktivovat",
  "registration.reset_password": "Obnovit hesla",
  "registration.error.existing_login":
    "Uživatel s tímto přihlašovacím jménem již existuje!",
  "registration.error.existing_email":
    "Uživatel s tímto e-mailem již existuje!",
  "registration.success": "Registrace uživatele {user_name} proběhla úspěšně.",

  "template_builder.info.title": "Model šablony",
  "template_builder.info.detail": "Detail modelu šablony",
  "template_builder.info.move": "Proklik na model šablony",
  "template_builder.info.description":
    "<strong>Model šablony </strong>definuje model podle kterého budou zobrazována data z vybrané tabulky.",
  "template_builder.info.data_model":
    "<strong>Datový model</strong> slouží k definici sloupců ze kterých jsou náslendně zobrazena data ve výsledném formuláři.",
  "template_builder.info.table_data":
    "tlačítko <strong>Data tabulky</strong> lze využít k prohlížení dat zdrojové tabulky šablony/modelu",
  "template_builder.info.row":
    "<strong>Řádek</strong> reprezentuje jeden sloupec z databáze",
  "template_builder.info.box_row":
    "<strong>Box v řádku</strong> reprezentuje vlastnosti tohoto sloupce. Tento sloupec může být napojen na jiné sloupce pomocí dat společnými mezi oběma sloupci. Spojení (JOIN) je stanoveno <i>Zobrazovaným sloupcem</i> ze zdrojového sloupce a <i>Sloupce s hodnotou</i> cílového sloupce.",
  "template_builder.info.left_side_btn":
    "<strong>Tlačítko + po levé straně </strong> přidá nové spojení",
  "template_builder.info.middle_btn":
    "<strong>Tlačítko × mezi boxy </strong> zruší spojení",
  "template_builder.info.alias":
    "<strong>Alias</strong> definuje jméno sloupce v přehledu/detailu",
  "template_builder.info.table":
    "<strong>Tabulka</strong> určuje ze které tabulky pochází data",
  "template_builder.info.column.1":
    "<strong>Sloupec s hodnotou</strong> určuje ze kterého sloupce pochází data",
  "template_builder.info.column.2":
    "<strong>Sloupec s hodnotou</strong> určuje který sloupec bude zobrazen v přehledu/detailu",
  "template_builder.info.type": "<strong>Typ</strong>",
  "template_builder.info.value":
    "<strong>Hodnota</strong> nijak neupravená hodnota z databáze",
  "template_builder.info.selection":
    "<strong>Výběr</strong> výběr z několika hodnot. <i>Hodnota</i> musí souhlasit s daty v databázi. <i>Text</i> určuje jak bude hodnota zobrazena uživateli",
  "template_builder.info.join":
    "<strong>JOIN</strong> spojení s jiným sloupcem",
  "template_builder.info.join.type":
    "<strong>Typ JOINu</strong> definuje jakým způsobem bude nakládáno s řádky tabulky které nesplňují podmínku spojení. <i>INNER</i> nezahrne záznamy ani z jedné tabulky. <i>LEFT</i> zahrne záznamy z cílové tabulky spojení. <i>RIGHT</i> zahrne záznamy ze zdrojové tabulky spojení.",
  "template_builder.info.condition":
    "<strong>+ Podmínka</strong> přidá podmínku kterou musí data ve sloupci splňovat.",
  "template_builder.info.condition.value":
    "<strong>Hodnota</strong> se buď rovná, je větší nebo menší přesné hodnotě v posledním poli",
  "template_builder.info.condition.similar":
    "<strong>Podobná jako</strong> např. _A% zobrazí všechny záznamy kde druhé písmeno je velké A (závislá na velikosti písmen zahrne i záznamy kde je druhé písmeno malé a)",
  "template_builder.info.new_row":
    "<strong>Nový řádek</strong> Přidá nový řádek do datového modelu",
  "template_builder.info.form_model":
    "<strong>Model formuláře</strong> definuje chování formuláře do kterého se uživatel dostane po kliknutí na Nový záznam/Upravit/Detail.",
  "template_builder.info.view":
    "<strong>Náhled</strong> zobrazuje výslednou prezentaci dat při zobrazení šablony.",
  "template_builder.info.table_detail":
    "<strong>Tabulka/Detail</strong> zobrazí výslednou tabulku/detail",
  "template_builder.info.sql":
    "<strong>SQL</strong> zobrazí SQL dotaz vygenerovaný podle datové šablony",
  "template_builder.data_model": "Datový model",
  "template_builder.data_model.filter": "Filtrovat tabulku",
  "template_builder.data_model.type.items": "Položky",
  "template_builder.data_model.type.sql": "SQL",
  "template_builder.data_model.type.info":
    "K nastavení datového modelu zvolte jednu z možností",
  "template_builder.data_model.sql.alert":
    "Aby se změny projevily, je potřeba aplikovat SQL dotaz",
  "template_builder.data_model.sql.upload": "Aplikovat SQL dotaz",
  "template_builder.data_model.sql.success":
    "SQL dotaz byl úspěšně aplikován. Dále nezapomeňte šablonu uložit.",
  "template_builder.data_model.error":
    "Při aplikování SQL dotazu došlo k chybě",
  "template_builder.model": "Model",
  "template_builder.table_data": "Data tabulky",
  "template_builder.presentation_model": "Prezentační model",
  "template_builder.presentation_model.no_mobile_layout":
    "Není definováno mobilní rozložení a tudíž není možné zobrazit šablonu mobilním uživatelům",
  "template_builder.presentation_model.display_conditions":
    "Podmínky zobrazení",
  "template_builder.presentation_model.editable_conditions":
    "Podmínky editovatelnosti",
  "template_builder.presentation_model.prefill_rules":
    "Pravidla předvyplňování",
  "template_builder.presentation_model.prefill_rules.condition": "Podmínka",
  "template_builder.presentation_model.prefill_rules.value":
    "Předvyplněná hodnota",
  "template_builder.presentation_model.title.alert":
    "Nebude možné vybrat typ sloupce Titulek, jelikož tento typ už má sloupec {name}.",

  "template_builder.is_template_heg": "Je šablona vztažená k HeG?: ",
  "template_builder.provider": "Pořadač: ",
  "template_builder.add_row": "Přidat řádek",
  "template_builder.items": "Položky",
  "template_builder.information": "Informace",
  "template_builder.chose_template": "Vybrat položkovou šablonu ",
  "template_builder.chose_join_column": "Vybrat spojovací sloupec ",
  "template_builder.alias_column_detail": "Spojovací sloupec (detail)",
  "template_builder.alias_column_item": "Spojovací sloupec (položka)",
  "template_builder.settings.template_item_order": "Pořadí šablony",
  "template_builder.settings.order_placeholder": "Pořadí",
  "template_builder.settings.filters": "Podmínky zobrazení",
  "template_builder.settings.filter_modal":
    "Podmínky zobrazení položkové šablony na detailu",

  "template.edit.row": "Datum by nemělo být před minimálním datem",
  "calender.clear": "Vymazat",
  "calender.cancel": "Zrušit",

  "template_builder.model.detail_templates": "Detailové šablony",
  "template_builder.model.overview_template": "Přehledová šablona",
  "template_builder.model.chosen_templates": "Vybrané šablony",
  "template_builder.model.empty_list": "Prázdný seznam",

  "template_builder.functions": "Funkce",
  "template_builder.functions.tooltip": "Tooltip",
  "template_builder.functions.confirm_before_running":
    "Potvrzovat při spuštění",
  "template_builder.functions.resolve_notification": "Řeší úkolovou notifikaci",
  "template_builder.functions.chose_functions": "Vybrat funkce",
  "template_builder.functions.item_title": "Šablona",
  "template_builder.functions.source_name": "tato šablona",
  "template_builder.functions.heg_number_class": "HeG Číslo třídy: ",
  "template_builder.functions.edit_buttons": "Úprava tlačítek funkcí",
  "template_builder.functions.icon": "Ikona na PC",
  "template_builder.functions.icon_mobile": "Ikona na mobilu",
  "template_builder.functions.color": "Barva na PC",
  "template_builder.functions.color_mobile": "Barva na mobilu",
  "template_builder.functions.alias": "Alias na PC",
  "template_builder.functions.alias_mobile": "Alias na mobilu",
  "template_builder.functions.override_left_gesture": "Přetáhnutí zleva",
  "template_builder.functions.override_right_gesture": "Přetáhnutí zprava",
  "template_builder.functions.display_conditions": "Podmínky pro zobrazení",
  "template_builder.functions.common_function": "Obecná funkce",
  "template_builder.settings": "Nastavení",
  "template_builder.settings.allow_edit": "Povolit editaci: ",
  "template_builder.settings.allow_copy": "Povolit kopírování",
  "template_builder.settings.allow_copy_in_row": "Povolit kopírování v řádku: ",
  "template_builder.settings.allow_edit_in_row": "Povolit editaci v řádku: ",
  "template_builder.settings.allow_delete": "Povolit smazání: ",
  "template_builder.settings.allow_create": "Povolit tvoření: ",
  "template_builder.settings.allow_create_in_row": "Povolit tvoření v řádku: ",
  "template_builder.settings.allow_table_export": "Povolit export tabulky: ",
  "template_builder.settings.allow_create.alert.detail":
    "Pro tvoření záznamů na základě detailu je potřeba navázat detailovou šablonu",
  "template_builder.settings.allow_create.alert.editInRow":
    "Pro tvoření záznamů v řádku šablony je třeba povolit editaci v řádku",
  "template_builder.settings.allow_report_export": "Povolit export reportu",
  "template_builder.settings.chose_action": "Vyberte akci",
  "template_builder.settings.model_form": "Model formuláře",
  "template_builder.settings.detail_template": "Šablona detailu",
  "template_builder.settings.item_template": "Položková šablona",
  "template_builder.settings.overview_template": "Přehledová šablona",
  "template_builder.settings.order": "Pořadí: ",
  "template_builder.settings.mandatory_items": "Povinné položky: ",
  "template_builder.settings.aggregation_groups": "Agregační skupiny",
  "template_builder.settings.heg_classes": "HeG třídy",
  "template_builder.settings.heg_folders": "HeG pořadače",
  "template_builder.settings.create_detail_template": "Vytvořit novou šablonu",
  "template_builder.settings.allow_unsubscribe": "Povolit odebrání notifikace",
  "template_builder.settings.allow_unsubscribe_tooltip":
    "Povolením této možnosti budou moci uživatelé odhlásit odběr notifikací této šablony. Admininstrátor může odhlásit odběr vždy.",
  "template_builder.settings.link_to_report": "Odkaz na report",
  "template_builder.settings.report_params": "Parametry reportu",
  "template_builder.settings.notification_is_task": "Notifikace je úkolem",
  "template_builder.settings.kpi.displayAsKpi": "Zobrazit jako KPI",
  "template_builder.settings.kpi.criticalThreshold": "Kritická hranice",
  "template_builder.settings.kpi.importantThreshold": "Důležitá hranice",
  "template_builder.view": "Náhled SQL dotazu",
  "template_builder.view.form": "Formulář",
  "template_builder.view.table": "Tabulka",
  "template_builder.view.sql": "SQL",
  "template_builder.view_model": "Zobrazit model",
  "template_builder.footer.save": "Uložit model",
  "template_builder.footer.help": "Nápověda",
  "template_builder.add_group": "Přidat skupinu",
  "template_builder.agr_groups.name": "Název: ",
  "template_builder.agr_groups.sum": "Suma",
  "template_builder.agr_groups.string_chain": "Spojení řetězců",
  "template_builder.agr_groups.items": "Položky: ",
  "template_builder.agr_groups.types": "Typ: ",
  "template_builder.agr_groups.from_model": "z modelu",
  "template_builder.agr_groups.static_value": "statická hodnota",
  "template_builder.agr_groups.item": "Položka datového modelu: ",
  "template_builder.agr_groups.value": "Hodnota: ",
  "template_builder.agr_groups.add_item": "Přidat položku",
  "template_builder.agr_groups.no_item": "Žádné položky",

  "value_definer.static_value": "statická hodnota",
  "value_definer.data_template_item": "Položka datového modelu",

  "template_builder.agr_group_editor.header": "Nastavení stylovaní výstupu",
  "template_builder.agr_group_editor.header_label": "Zobrazit jako:",
  "template_builder.agr_group_editor.as_title": "Titulek",
  "template_builder.agr_group_editor.as_color": "Barva",
  "template_builder.agr_group_editor.as_icon": "Ikona",
  "template_builder.agr_group_editor.as_default": "Text",
  "template_builder.agr_group_editor.color_options": "Nastavení barev",
  "template_builder.agr_group_editor.icon_options": "Nastavení ikon",
  "template_builder.agr_group_editor.range_type.absolute": "Absolutní",
  "template_builder.agr_group_editor.range_type.relative": "Relativní",
  "template_builder.agr_group_editor.today": "Dnes",

  "template_builder.set_function_icon": "Nastavte vzhled ikony",
  "template_builder.set_color_appearance": "Nastavte barvu zobrazení",
  "template_builder.save_success": "úspěšně uloženo",
  "template_builder.box.default_item":
    "Výchozí položka (reprezentuje Id tabulky)",
  "template_builder.box.editable": "Upravitelný: ",
  "template_builder.box.disable_trigger_events":
    "Editovat bez instanční logiky",
  "template_builder.box.alias": "Alias: ",
  "template_builder.box.existing_join": "Existující JOIN:",
  "template_builder.box.sorting_order": "Pořadí řazení:",
  "template_builder.box.sorting_type": "Typ řazení: ",
  "template_builder.box.sorting_asc": "Vzestupně",
  "template_builder.box.sorting_desc": "Sestupně",
  "template_builder.box.table": "Tabulka: ",
  "template_builder.box.column_value": "Sloupec s hodnotou: ",
  "template_builder.box.column_active": "Zobrazovaný sloupec: ",
  "template_builder.box.type": "Typ: ",
  "template_builder.box.dynRel": "Dynamický vztah: ",
  "template_builder.box.staticRel": "Statický vztah: ",
  "template_builder.box.relation_id": "Číslo relace",
  "template_builder.box.is_extension_editable": "Editovat tabulku:",
  "template_builder.box.is_extension_editable.info":
    "Editovat tabulku zaškrtněte ve chvíli, kdy chcete, aby uživatel mohl editovat kromě základní tabulky šablony i tabulky navázané.",
  "template_builder.box.select.value": "Hodnota",
  "template_builder.box.select.static": "Statický výběr",
  "template_builder.box.select.dynamic": "Dynamický výběr",
  "template_builder.box.select.join": "JOIN",
  "template_builder.box.select.hidden": "Schovaný",
  "template_builder.box.select.heg_file": "HeG Soubory",
  "template_builder.box.select.file": "Soubory",
  "template_builder.box.select.agr_group": "Agr. Skupina",
  "template_builder.box.select.aggregation": "Agregační skupina",
  "template_builder.box.select.category": "Kategorie",
  "template_builder.box.select.rel_number": "Číslo vztahu: ",
  "template_builder.box.select.file_folder_number": "Číslo pořadače: ",
  "template_builder.box.select.subject_number_column":
    "Sloupec s číslem subjektu: ",
  "template_builder.box.select.values": "Hodnoty výběru: ",
  "template_builder.box.select.values.label": "Popisek",
  "template_builder.box.select.values.value": "Hodnota",
  "template_builder.box.select.values.range": "Rozsah",
  "template_builder.box.select.values.range_type": "Relativní datum",
  "template_builder.box.select.join_type": "Typ JOINu",
  "template_builder.box.select.inner_join": "INNER JOIN",
  "template_builder.box.select.left_join": "LEFT JOIN",
  "template_builder.box.select.right_join": "RIGHT JOIN",
  "template_builder.box.select.condition": "Podmínka",
  "template_builder.box.select.column": "sloupec: {display_column}",
  "template_builder.box.select.like": "Podobná jako",
  "template_builder.box.select.dependency": "závislá na velikosti písmen: ",
  "template_builder.box.select.label": "Nadpis notifikace",
  "template_builder.box.select.link": "Odkaz na šablonu",
  "template_builder.box.select.link.label": "Detailová šablona",
  "template_builder.box.select.dateFrom": "Datum od",
  "template_builder.box.select.dateTo": "Datum do",
  "template_builder.box.select.title": "Titulek",
  "template_builder.box.select.icon": "Ikona",
  "template_builder.box.select.color": "Barva",
  "template_builder.box.select.overviewSelect": "Výběr z přehledu",
  "template_builder.box.template_id": "Id šablony:",
  "template_builder.box.select.relation_type": "Typ vztahu",
  "template_builder.box.select.none_relation": "Žádný",
  "template_builder.box.select.static_relation": "Statický",
  "template_builder.box.select.dynamic_relation": "Dynamický",
  "template_builder.box.select.priority_settings": "Prioritní nastavení",
  "template_builder.box.select.priority": "Prioritní",
  "template_builder.box.select.normal": "Normální",
  "template_builder.box.select.highest_priority": "Nejvyšší",
  "template_builder.box.select.high_priority": "Vysoká",
  "template_builder.box.select.medium_priority": "Střední",
  "template_builder.box.select.low_priority": "Nízká",
  "template_builder.box.select.lowest_priority": "Nejnižší",

  "template_builder.box.select.file.table": "Tabulka",
  "template_builder.box.select.file.content_column_name": "Sloupec pro data",
  "template_builder.box.select.file.name_column_name":
    "Sloupec pro název souboru",
  "template_builder.box.select.file.key_column_name":
    "Sloupec pro unikátní klíč",

  "template_builder.box.select.file.content_format_type": "Formát dat",
  "template_builder.box.select.file.content_format_type.byte_array":
    "Pole bytů",
  "template_builder.box.select.file.content_format_type.base64_string":
    "Textový řetězec",
  "template_builder.box.select.file.identifier_type": "Typ identifikátoru",
  "template_builder.box.select.file.identifier_type.recordId": "Id záznamu",
  "template_builder.box.select.file.identifier_type.aggGroup":
    "Agregační skupiny",

  "template_builder.box.attribute_format": "Formát atributu",
  "template_builder.box.value_format": "Formát hodnoty",
  "template_builder.box.column_format": "Formát sloupce",
  "template_builder.box.item_settings": "Nastavení atributu {item_name}",

  "template_builder.box.format.attribute_text_align": "Zarovnání atributu:",
  "template_builder.box.format.value_text_align": "Zarovnání hodnoty:",
  "template_builder.box.format.text_align.center": "Na střed",
  "template_builder.box.format.text_align.left": "Vlevo",
  "template_builder.box.format.text_align.right": "Vpravo",

  "template_builder.box.format.display_variant": "Varianta zobrazení:",
  "template_builder.box.format.display_variant.icon": "Ikona",
  "template_builder.box.format.display_variant.text": "Text",
  "template_builder.box.format.display_variant.text_icon": "Ikona + text",
  "template_builder.box.format.display_variant.none": "Nezobrazit nic",

  "template_builder.box.format.mobile_variant":
    "Varianta zobrazení na mobilních zařízeních:",
  "template_builder.box.format.mobile_variant.use_normal":
    "Stejně jako na webu",

  "template_builder.box.format.show_on_mobile":
    "Zobrazit na mobilních zařízeních:",
  "template_builder.box.format.show_on_mobile.show": "Zobrazit",
  "template_builder.box.format.show_on_mobile.hide": "Sktýt",

  "template_builder.box.format.number": "Formátování čísla",
  "template_builder.box.format.number.round_to": "Zaokrouhlit na:",
  "template_builder.box.format.number.rounding_direction": "Směr zaokrouhlení:",
  "template_builder.box.format.number.rounding_direction.up": "Nahoru",
  "template_builder.box.format.number.rounding_direction.down": "Dolů",
  "template_builder.box.format.number.unit": "Jednotka:",
  "template_builder.box.format.number.thousandsSeparator": "Oddělovač tisíců:",
  "template_builder.box.format.number.divisor": "Dělitel:",
  "template_builder.box.format.number.view": "Náhled čísla:",
  "template_builder.box.format.number.min_value": "Minimální hodnota:",
  "template_builder.box.format.number.max_value": "Maximální hodnota:",
  "template_builder.box.format.number.showNumberAsTime": "Zobrazit jako čas:",

  "template_builder.box.format.date.date_formatting": "Formátování data",
  "template_builder.box.format.date.date_format": "Formát data:",
  "template_builder.box.format.date.date_format.date": "Datum",
  "template_builder.box.format.date.date_format.time": "Čas",
  "template_builder.box.format.date.date_format.datetime": "Datum a čas",
  "template_builder.box.format.date.date_format.month": "Měsíc",
  "template_builder.box.format.date.date_format.year": "Rok",
  "template_builder.box.format.date.min_value": "Minimální hodnota:",
  "template_builder.box.format.date.max_value": "Maximální hodnota:",

  "template_builder.box.format.date.text_formatting": "Formátování textu",
  "template_builder.box.format.date.text_format.as_textarea":
    "Zobrazit jako textarea",

  "template_builder.box.format.date.text_format.as_phone_mail":
    "Zobrazit jako tel./email",
  "template_builder.box.format.required": "Povinné",

  "template_builder.box.format.file.file_settings": "Nastavení souborů",
  "template_builder.box.format.file.file_size": "Velikost souboru (kB)",
  "template_builder.box.format.file.allowed_file_types":
    "Povolené typy souborů",

  "template_builder.column_position_editor.add_item": "Přidat položku",
  "template_builder.column_position_editor.type": "Typ",
  "template_builder.column_position_editor.label": "Popis sloupce",
  "template_builder.column_position_editor.value": "Hodnota",
  "template_builder.column_position_editor.cancel": "Zrušit",
  "template_builder.column_position_editor.add": "Přidat",
  "template_builder.column_position_editor.number_of_columns": "Počet sloupců",
  "template_builder.column_position_editor.number_of_rows": "Počet řádků",
  "template_builder.column_position_editor.rowspan": "Sloučit řádky",
  "template_builder.column_position_editor.colspan": "Sloučit sloupce",
  "template_builder.column_position_editor.edit_mode.turn_on":
    "Zapnout editační mód",
  "template_builder.column_position_editor.edit_mode.turn_off":
    "Vypnout editační mód",
  "template_builder.column_position_editor.same_for_mobile":
    "Stejný vzhled pro mobil",
  "template_builder.column_position_editor.number_range":
    "Číslo musí být v rozmezí 1 až {range}",

  "template_builder.column_position_editor.entity_position": "Pozice entity",
  "template_builder.column_position_editor.values": "Hodnoty",
  "template_builder.column_position_editor.labels": "Popisky",
  "template_builder.column_position_editor.delimiters": "Oddělovače",
  "template_builder.column_position_editor.delimiter.position": "Pozice",
  "template_builder.column_position_editor.delimiter.pattern": "Vzor",
  "template_builder.column_position_editor.delimiter.empty": "Prázdná",
  "template_builder.column_position_editor.delimiter.line": "Čára",
  "template_builder.column_position_editor.delimiter.dotted_line":
    "Přerušovaná čára",
  "template_builder.column_position_editor.delimiter.horizontal":
    "Horizontální",
  "template_builder.column_position_editor.delimiter.vertical": "Vertikální",
  "template_builder.column_position_editor.delimiter.line_horizontal":
    "Horizontální čára",
  "template_builder.column_position_editor.delimiter.line_vertical":
    "Vertikální čára",
  "template_builder.column_position_editor.delimiter.dotted_line_horizontal":
    "Přerušovaná horizontální čára",
  "template_builder.column_position_editor.delimiter.dotted_line_vertical":
    "Přerušovaná vertikální čára",
  "template_builder.column_position_editor.delimiter.type": "Typ oddělovače",

  "template_builder.errorMessage.duplicateSelectValues":
    "některá z prezentačních položek šablony má možnosti výběru se stejnou hodnotou",
  "template_builder.errorMessage.duplicateSelectNames":
    "některá z prezentačních položek šablony má možnosti výběru se stejným textem",
  "template_builder.errorMessage.missingHegClassId": "Vyberte HeG třídu.",
  "template_builder.errorMessage.missingHegFolderId": "Vyberte HeG pořadač.",
  "template_builder.errorMessage.missingItemColumnAlias":
    "Vyberte spojovací sloupec položkové šablony.",
  "template_builder.errorMessage.missing_detail_mobile_layout":
    "U detailu je nutné nastavit mobilní rozložení buněk",
  "template_builder.errorMessage.emptySortOrder":
    "Jedna z položek má nastaven typ řazení, ale nemá nastaveno pořadí řazení",
  "template_builder.errorMessage.missingHegFileRelation":
    "Jedna z položek má typ Heg File, ale nemá přiřazenou propojovací šablonu",
  "template_builder.errorMessage.missingColumn":
    "Jedna z položek nemá nastavený propojovací sloupec",
  "template_builder.errorMessage.missingDisplayColumn":
    "Jedna z položek nemá nastavený zobrazovací sloupec",
  "template_builder.sql_query.copy": "Kopírovat dotaz do schránky",
  "template_builder.sql_query.stale_data":
    "Neuložené změny v modelu se nepromítají do náhledu SQL dotazu. " +
    "Zobrazovaný dotaz odpovídá poslední uložené verzi šablony. " +
    "Rozpracované změny je nutné uložit, aby se promítly do náhledu dotazu.",

  "template_builder.sql_query.save_and_reload":
    "Uložit model a aktualizovat dotaz",

  "template_builder.data_reload.message": "Data nejsou aktuální",
  "template_builder.data_reload.button": "Aktualizovat data",
  "template_builder.validation.missing_detail":
    "Při zapnuté editaci nebo vytváření a editaci musí mít přiřazený detail.",
  "template_builder.not_mapped":
    "Chybí mapování! Zkontrolujte výchozí mapování na datovém zdroji šablony.",

  "users.title": "Uživatelé",
  "users.add_user": "Přidat uživatele",
  "users.show_mapping": "Zobrazit mapování",
  "users.user_mapping.title":
    "Mapování datových zdrojů pro uživatele {userName}",
  "users.user_mapping.map_user": "Namapovat uživatele",
  "users.user_mapping.remove_user": "Odmapovat uživatele",
  "users.user_mapping.map_user.title": "Datový zdroj {dataSourceName}",
  "users.user_mapping.map_user.input": "HeG uživatelské jméno:",

  "users.user_mapping.error": "Mapování na uživatele {newHegUser} selhalo:",
  "users.send_credentials": "Odeslat přihlášení",
  "users.send_credentials.user.success":
    "Uživateli {userName} byly odeslány přihlašovací údaje.",
  "users.send_credentials.users.success":
    "Vybraným uživatelům byly odeslány přihlašovací údaje.",
  "users.send_credentials.error":
    "Při odesílání přihlašovacích údajů došlo k chybě. Kontaktuje prosím administrátora.",

  "personalization.title": "Přizpůsobení vzhledu aplikace",
  "personalization.colors": "Barvy",
  "personalization.version": "Verze: {version}",
  "personalization.chose_color": "Vyberte barvu",
  "personalization.colors.changeBg": "<strong>Změnit barvu pozadí</strong>",
  "personalization.colors.changeBg.modal": "Vyberte barvu pozadí",
  "personalization.colors.primary":
    "<strong>Změnit primární barvu</strong> (barva modulů, barva základních tlačítek nebo barva menu)",
  "personalization.colors.primary.modal": "Vyberte primární barvu",
  "personalization.colors.secondary":
    "<strong>Změnit sekundární barvu</strong> (ostatní detaily a nadpisy)",
  "personalization.colors.secondary.modal": "Vyberte sekundární barvu",
  "personalization.colors.restore_defaults": "Vrátit původní barvy",
  "personalization.main_page": "Hlavní stránka",
  "personalization.main_page.title": "Nadpis",
  "personalization.main_page.description": "Popisek",
  "personalization.main_page.templates_count":
    "Počet viditelných šablon na modulu",
  "personalization.main_page.visibility.title": "Viditelný nadpis",
  "personalization.main_page.visibility.description": "Viditelný popisek",
  "personalization.main_page.visibility.google_play": "Viditelný Google Play",
  "personalization.main_page.visibility.apple_store": "Viditelný Apple Store",
  "personalization.google_play.attribution":
    "Google Play a logo Google Play jsou ochranné známky společnosti Google LLC.",
  "personalization.login.title": "Nastavení povolených způsobů přihlašování",
  "personalization.login.standard": "Login a heslo",
  "personalization.login.google": "Google přihlášení",
  "personalization.login.microsoft": "Microsoft přihlášení",
  "personalization.login.directory": "Active directory",
  "personalization.data_format.title": "Přizpůsobení dat aplikace",
  "personalization.data_format.number_of_decimals": "Počet desetinných míst",
  "personalization.user_section": "Uživatelská část",
  "personalization.user_secttion.bug_report": "Umožnit nahlášení chyby",
  "personalization.user_secttion.send_feedback":
    "Umožnit odeslat zpětnou vazbu",
  "personalization.user_secttion.auditlog": "Auditlog",
  "personalization.user_secttion.days_to_keep_log":
    "Počet dní pro uchování logu",

  "personalization.error.no_selected_login":
    "Je potřeba povolit alespoň jeden způsob přihlášení",

  "segments.decline_icon": "Zrušit ikonu",
  "segments.find_icon": "Najdi ikonu podle názvu",
  "segments.chose_icon": "Vyberte ikonu",
  "segments.module.colors.chose": "Vybrat",
  "segments.module.colors.decline": "Zrušit barvu",
  "segments.admin_only": "Tato sekce je dostupná pouze pro administrátory.",
  "segments.password.alert": "Heslo pro namapovaného uživatele není správné.",
  "segments.password.heg_pswd": "Zadejte heslo do HeG: ",
  "segments.password.set": "Nastavit",
  "segments.password.change_mapping": "Změnit mapování",
  "segments.data_source.title": "Datový zdroj",
  "segments.data_source.placeholder": "Vyberte zdroj",
  "segments.tables.placeholder.loading": "Náčítám tabulky ...",
  "segments.tables.placeholder.select_data_source_first":
    "Nejprve vyberte datový zdroj",
  "segments.tables.placeholder.chose": "Vyberte tabulku",
  "segments.tables.add": "Přidat",
  "segments.tables.chose_value": "Vyberte hodnotu",
  "segments.delete_confirm": "Opravdu chcete smazat tuto položku?",
  "segments.file_list.alert":
    "Zobrazení souborů není nyní podporováno na FLOWIO pro Android. Můžete si zobrazit následující odkaz v prohlížeči.",
  "segments.file_list.multiple_files": "Soubory ({count})",
  "segments.file_list.no_files": "Žádné soubory.",
  "segments.file_input.tooltip.upload_file": "Nahrát novou přílohu",
  "segments.file_input.error": "Chyba při ukládání souboru (souborů)",
  "segments.file_input.download.error": "Chyba při získávání souboru",
  "segments.file_input.files_upload.error":
    "Je nám líto, ale následující soubory se nám nepodařilo nahrát: {fileNames}",
  "segments.file_input.files_delete.error":
    "Je nám líto, ale následující soubory se nám nepodařilo smazat: {fileNames}",
  "segments.file_input.tooltip.disable_reason":
    "Nahrát přílohu je možné pouze u existujících záznamů",
  "segments.heg.alert": "Uživatel FLOWIO není namapovaný na uživatele HeG.",
  "segments.heg.user": "HeG uživatel:",
  "segments.map": "Namapovat",
  "segments.load_csv": "Nahrát CSV soubor",
  "segments.permissions.insufficient": "Nedostatečné oprávnění",
  "segments.functions.title": "<strong>Funkce</strong>",
  "segments.functions.selected_items": "Počet vybraných položek: {count}",
  "segments.functions.table_header": "Funkce: ",
  "segments.functions.start": "Spustit",
  "segments.table.search_info":
    "Bylo zobrazeno prvních 100000 záznamů z {rowCount}. Použijte hledání k zúžení výsledku.",
  "segments.table.row_numbers": "Počet záznamů na stránce: ",
  "segments.table_search.title": "Vyhledávání nad sloupci",
  "segments.table_search.from": "<strong>Od: </strong>",
  "segments.table_search.to": "<strong>Do: </strong>",
  "segments.table.actions": "Akce",
  "segments.table.actions.more": "Více akcí",
  "segments.functions.select_all": "Vybrat vše",
  "segments.choose_conditions": "Vyberte podmínky",

  "login.app_account": "<strong>Účet aplikace</strong>",
  "login.placeholder.login": "Přihlašovací jméno",
  "login.user_not_exist": "Uživatel {text} neexistuje",
  "login.please_change_password":
    "Vaše heslo bylo resetováno. Odkaz pro jeho obnovení Vám byl zaslán do emailu.",
  "login.wrong_password": "Chybné heslo",
  "login.deactivated_account":
    "Vaše přihlašovací údaje byly deaktivovány. Kontaktujte administrátora!",
  "login.login": "Přihlásit se",
  "login.logout": "Odhlásit se",
  "login.flowio_message":
    "Jediná podniková aplikace, kterou Vaši zaměstnanci doopravdy potřebují!",
  "login.google.invalid_settings":
    "Nevalidní nastavení, prosím kontaktuje administrátora",
  "login.reset_password": "Obnovit heslo",
  "login.change_password": "Změnit heslo",
  "login.personal_settings": "Osobní nastavení",
  "login.bugs_overview": "Zobrazit přehled chyb",
  "login.language": "Jazyk",
  "login.mapped_data_sources": "Mapované datové zdroje",
  "login.change_password.info_message":
    "Po úspěšné změně hesla budete z aplikace odhlášeni aby jste se mohli přihlásit pod novým heslem",
  "login.active_directory.error":
    "Chyba při přihlášení pomocí aktivního adresáře",

  "reset_password.change": "změnit heslo",

  "x2y.table_data.unselected": "Nevybrané",
  "x2y.table_data.selected": "Vybrané",
  "x2y.no_items_found": "Nebyly nalezeny žádné záznamy k výběru",

  "icon_selector.click_here_to_select": "Vyberte ikonu kliknutím zde",

  "favourite_templates.empty_list": "Nemáte zvolené žádné oblíbené šablony.",
  "notifications.initial_load": "Vaše notifikace se načítají",
  "notifications.template.empty": "Nemáte žádné šablonové notifikace",
  "notifications.system.title": "Systémová notifikace",
  "notifications.system":
    "Bohužel Vám nemůžeme zobrazit notifikace ze šablon: [{templateNames}], protože nemáte aktivní mapování na datový zdroj {datasourceName}. Pro namapování klikněte zde",
  "notifications.system.notification":
    "Systémová notifikace: Notifikační šablona",
  "notifications.system.default_mapping":
    "Systémová notifikace: Výchozí mapování",

  "modal.confirmation_modal.delete_message.title": "Potvrzení smazání",
  "modals.confirmation_modal.delete_message":
    "Jste si jistí, že chcete tento záznam smazat? Tato akce je nevratná.",
  "modals.confirmation_modal.reset_pass_message":
    "Jste si jistí, že chcete obnovit heslo? Tato akce je nevratná.",
  "modals.confirmation_modal.reset_pass_multiple_message":
    "Jste si jistí, že chcete pro všechny zvolené uživatele obnovit heslo? Tato akce je nevratná.",
  "modals.confirmation_modal.deactivate_message":
    "Jste si jistí, že chcete deaktivovat uživatele?",
  "modals.confirmation_modal.deactivate_accounts_message":
    "Jste si jistí, že chcete deaktivovat všechny zvolené uživatele? ",

  "sortable.item": "Položka",

  "hwr.annual_evaluation": "Roční hodnocení",
  "hwr.adaptation_plan": "Adaptační plán",
  "hwr.personal_dev_plan": "Plán osobního rozvoje",
  "hwr.echos_evaluation": "Hodnocení potenciálu",
  "hwr.back": "Zpět",
  "hwr.forward": "Pokračovat v hodnocení",
  "hwr.show": "Zobrazit",
  "hwr.enter": "Vstoupit",

  "hwr.rocni_hodnoceni.old": "Hodnocení předešlé",
  "hwr.rocni_hodnoceni.current": "Hodnocení aktuální",
  "hwr.rocni_hodnoceni.future": "Hodnocení příští",
  "hwr.rocni_hodnoceni.msg0001": "Roční hodnocení",
  "hwr.rocni_hodnoceni.msg0002": "Údaje o zaměstnanci",
  "hwr.rocni_hodnoceni.msg0003": "Předvyplněné údaje jsou kompletní",
  "hwr.rocni_hodnoceni.msg0004": "Jméno",
  "hwr.rocni_hodnoceni.msg0005": "Datum narození",
  "hwr.rocni_hodnoceni.msg0006": "Příjmení",
  "hwr.rocni_hodnoceni.msg0007": "Datum vstupu do skupiny",
  "hwr.rocni_hodnoceni.msg0008": "Os. č. KZ",
  "hwr.rocni_hodnoceni.msg0009": "Datum zahájení práce na současné pozici",
  "hwr.rocni_hodnoceni.msg0010": "Název funkce",
  "hwr.rocni_hodnoceni.msg0011": "Datum nároku na důchod",
  "hwr.rocni_hodnoceni.msg0012": "GGS Grade",
  "hwr.rocni_hodnoceni.msg0013": "Klasifikace Veolia",
  "hwr.rocni_hodnoceni.msg0014": "Činnost",
  "hwr.rocni_hodnoceni.msg0015": "Činnost O/P/R",
  "hwr.rocni_hodnoceni.msg0016": "Kategorie pozice",
  "hwr.rocni_hodnoceni.msg0017": "Úroveň řízení",
  "hwr.rocni_hodnoceni.msg0018": "Místo působení",
  "hwr.rocni_hodnoceni.msg0019": "Rok hodnocení",
  "hwr.rocni_hodnoceni.msg0020": "Business Line",
  "hwr.rocni_hodnoceni.msg0021": "Země",
  "hwr.rocni_hodnoceni.msg0022": "Datum rozhovoru",
  "hwr.rocni_hodnoceni.msg0023": "Společnost / Region",
  "hwr.rocni_hodnoceni.msg0024": "Typ odměny",
  "hwr.rocni_hodnoceni.msg0026": "Funkce nadřízeného",
  "hwr.rocni_hodnoceni.msg0027": "Základní odpovědnost a hlavní úkoly",
  "hwr.rocni_hodnoceni.msg0028": "Nadřízený",
  "hwr.rocni_hodnoceni.msg0029": "Náplň práce",
  "hwr.rocni_hodnoceni.msg0030": "Komentáře a návrhy zaměstnance",
  "hwr.rocni_hodnoceni.msg0031": "Komentáře a návrhy nadřízeného",
  "hwr.rocni_hodnoceni.msg0032": "Zpět",
  "hwr.rocni_hodnoceni.msg0033": "Pokračovat v hodnocení",
  "hwr.rocni_hodnoceni.msg0034": "Pokračovat bez kontrol....",
  "hwr.rocni_hodnoceni.msg0035": "Hodnocení individuálních cílů - uplynulý rok",
  "hwr.rocni_hodnoceni.msg0036": "Cíl",
  "hwr.rocni_hodnoceni.msg0037": "Název cíle",
  "hwr.rocni_hodnoceni.msg0038": "Ukazatel výkonnosti",
  "hwr.rocni_hodnoceni.msg0039": "Termín pro splnění cíle",
  "hwr.rocni_hodnoceni.msg0040": "Váha %",
  "hwr.rocni_hodnoceni.msg0041": "Splnění (%)",
  "hwr.rocni_hodnoceni.msg0042": "Vyhodnocení cíle",
  "hwr.rocni_hodnoceni.msg0043": "Komentář",
  "hwr.rocni_hodnoceni.msg0044":
    "Stanovení individuálních cílů pro nadcházející rok",
  "hwr.rocni_hodnoceni.msg0045": "Stanovte 2 až 5 individuálních cílů",
  "hwr.rocni_hodnoceni.msg0046": "Načtení minulého cíle",
  "hwr.rocni_hodnoceni.msg0047": "Název cíle",
  "hwr.rocni_hodnoceni.msg0048": "Ukazatel výkonnosti",
  "hwr.rocni_hodnoceni.msg0049": "Termín pro splnění cíle",
  "hwr.rocni_hodnoceni.msg0050": "Váha %",
  "hwr.rocni_hodnoceni.msg0051": "Komentář",
  "hwr.rocni_hodnoceni.msg0052": "Hodnocení",
  "hwr.rocni_hodnoceni.msg0053": "Komentář\n(příklady, návrhy, ...)",
  "hwr.rocni_hodnoceni.msg0054": "Odpovědnost:",
  "hwr.rocni_hodnoceni.msg0055": "Solidarita:",
  "hwr.rocni_hodnoceni.msg0056": "Respekt:",
  "hwr.rocni_hodnoceni.msg0057": "Inovace:",
  "hwr.rocni_hodnoceni.msg0058": "Orientace na zákazníka:",
  "hwr.rocni_hodnoceni.msg0059":
    "Jak v nadcházejícím roce aktivně přispějete k bezpečnosti a ochraně zdraví při práci?",
  "hwr.rocni_hodnoceni.msg0060": "Angažovanost v\noblasti BOZP",
  "hwr.rocni_hodnoceni.msg0061": "Určete 2 až 3 silné stránky",
  "hwr.rocni_hodnoceni.msg0062": "Dovednost",
  "hwr.rocni_hodnoceni.msg0063": "Kategorie dovedností",
  "hwr.rocni_hodnoceni.msg0064": "Popis",
  "hwr.rocni_hodnoceni.msg0065": "Komentář",
  "hwr.rocni_hodnoceni.msg0066": "Stanovte 1 až 3 oblasti k rozvoji",
  "hwr.rocni_hodnoceni.msg0067": "Jazykové kompetence",
  "hwr.rocni_hodnoceni.msg0068": "AJ úroveň znalosti",
  "hwr.rocni_hodnoceni.msg0069": "FR úroveň znalosti",
  "hwr.rocni_hodnoceni.msg0070": "Jiný jazyk - výběr",
  "hwr.rocni_hodnoceni.msg0071": "Jiný jazyk - úroveň znalosti",
  "hwr.rocni_hodnoceni.msg0072": "Geografická mobilita",
  "hwr.rocni_hodnoceni.msg0073": "Upřesněte (region, země,...)",
  "hwr.rocni_hodnoceni.msg0074": "Jen v rámci ČR",
  "hwr.rocni_hodnoceni.msg0075": "V rámci 1-2 let?",
  "hwr.rocni_hodnoceni.msg0076": "V rámci 3-5 let?",
  "hwr.rocni_hodnoceni.msg0077": "Komentář zaměstnanec",
  "hwr.rocni_hodnoceni.msg0078": "Přání pro kariérní rozvoj",
  "hwr.rocni_hodnoceni.msg0079":
    "Upřesnění (činnost, pracovní zařazení, za jakých podmínek, kdy)",
  "hwr.rocni_hodnoceni.msg0080": "Příští pozice (pokud je známa)",
  "hwr.rocni_hodnoceni.msg0081": "Celkový komentář nadřízeného",
  "hwr.rocni_hodnoceni.msg0082":
    "Přejete si rozhovor s manažerem LZ ohledně Vaší mobility/kariéry?",
  "hwr.rocni_hodnoceni.msg0083":
    "Vyplňte jen u zaměstnance, kterému v následujících 3 letech vzniká nárok na starobní důchod:",
  "hwr.rocni_hodnoceni.msg0084":
    "Přejete si v nejbližších 3 letech odejít do důchodu?",
  "hwr.rocni_hodnoceni.msg0085": "Řádný",
  "hwr.rocni_hodnoceni.msg0086": "Předčasný",
  "hwr.rocni_hodnoceni.msg0087": "Komentář",
  "hwr.rocni_hodnoceni.msg0088": "Vzdělávání v předchozím roce ({year})",
  "hwr.rocni_hodnoceni.msg0089": "Akce",
  "hwr.rocni_hodnoceni.msg0090": "Datum",
  "hwr.rocni_hodnoceni.msg0091": "Kategorie dovedností",
  "hwr.rocni_hodnoceni.msg0092": "Dosažené výsledky",
  "hwr.rocni_hodnoceni.msg0093":
    "Požadované vzdělávání v nadcházejícím roce ({year})",
  "hwr.rocni_hodnoceni.vzdelani.sub_info":
    "(Týká se dovedností v nynější roli nebo dovedností potřebných pro postup na další pozici)",
  "hwr.rocni_hodnoceni.msg0094": "Dovednost {dovednost}",
  "hwr.rocni_hodnoceni.msg0095": "Vzdělávací akce",
  "hwr.rocni_hodnoceni.msg0096": "Seznam vzděl. akcí",
  "hwr.rocni_hodnoceni.msg0097": "Termín",
  "hwr.rocni_hodnoceni.msg0098": "Název vzděl. akce",
  "hwr.rocni_hodnoceni.msg0099": "Očekávané výsledky",

  "hwr.rocni_hodnoceni.msg0100": "Souhrnné hodnocení",
  "hwr.rocni_hodnoceni.msg0101": "Hodnocení",
  "hwr.rocni_hodnoceni.msg0102": "Komentář zaměstnance",
  "hwr.rocni_hodnoceni.msg0103": "Komentář hodnotitele",
  "hwr.rocni_hodnoceni.msg0104": "Podpis hodnotitele",
  "hwr.rocni_hodnoceni.msg0105": "Dne",
  "hwr.rocni_hodnoceni.msg0106": "Podpis zaměstnance",
  "hwr.rocni_hodnoceni.msg0107": "Vyhodnocení kvalitativních ukazatelů",
  "hwr.rocni_hodnoceni.msg0108": "Cíl",
  "hwr.rocni_hodnoceni.msg0109": "Definice cíle",
  "hwr.rocni_hodnoceni.msg0110": "Váha (%)",
  "hwr.rocni_hodnoceni.msg0111": "Splnění (%)",
  "hwr.rocni_hodnoceni.msg0112": "Vyhodnocení individuálních cílů",
  "hwr.rocni_hodnoceni.msg0113": "Stanovené individuální cíle",
  "hwr.rocni_hodnoceni.msg0114": "Definice cíle",
  "hwr.rocni_hodnoceni.msg0115": "Kategorie cíle",
  "hwr.rocni_hodnoceni.msg0116": "Příslib Kč",
  "hwr.rocni_hodnoceni.msg0117": "Vyhodnocení cíle",
  "hwr.rocni_hodnoceni.msg0118": "Návrh k výplatě Kč",
  "hwr.rocni_hodnoceni.msg0119": "Komentář (nepovinné)",
  "hwr.rocni_hodnoceni.msg0120":
    "Není vyplněn Datum rozhovoru, Základní odpovědnost a hlavní úkoly.",
  "hwr.rocni_hodnoceni.msg0121": "Není vyplněn datum rozhovoru.",
  "hwr.rocni_hodnoceni.msg0122": "Hodnocení je uzamknuto",
  "hwr.rocni_hodnoceni.bozp.value":
    'Pole "Angažovanost v oblasti BOZP" je povinné.',
  "hwr.rocni_hodnoceni.msg0123": "Suma vah musí být 100%.",
  "hwr.rocni_hodnoceni.msg0124":
    "Pokud je vyplněno vyhodnocení, splnění musí být zadáno.",
  "hwr.rocni_hodnoceni.msg0125":
    "Vyhodnocení musí být vyplněno pro každý definovaný cíl.",
  "hwr.rocni_hodnoceni.msg0126": "Cíl {cil} není vyplněn.",
  "hwr.rocni_hodnoceni.msg0127":
    "U odměny typu SM je nutné uvést váhu pro každý definovaný cíl.",
  "hwr.rocni_hodnoceni.msg0128":
    "Je-li procentní váha u některého cíle vyplněna, musí být uvedena na u všech vyplněných cílů.",
  "hwr.rocni_hodnoceni.msg0129":
    "Cíle: Pokud je některá z hodnot zadána, Definice je povinná.",
  "hwr.rocni_hodnoceni.msg0130": "Není vyplněno hodnocení.",
  "hwr.rocni_hodnoceni.msg0131": "Odpovědnost",
  "hwr.rocni_hodnoceni.msg0132": "Solidarita",
  "hwr.rocni_hodnoceni.msg0133": "Respekt",
  "hwr.rocni_hodnoceni.msg0134": "Inovace",
  "hwr.rocni_hodnoceni.msg0135": "Orientace na zákazníka",
  "hwr.rocni_hodnoceni.msg0136": "Nejsou vyplněny všechny komentáře.",
  "hwr.rocni_hodnoceni.msg0137":
    "Pole 'Angažovanost v oblasti BOZP' je povinné.",
  "hwr.rocni_hodnoceni.msg0138":
    "Silné stránky: Dovednost {kompetence} není vyplněna.",
  "hwr.rocni_hodnoceni.msg0139":
    "Silné stránky: Je-li vyplněna Kategorie dovednosti {idx}, musí být k ní vybrána alespoň jedna konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0140":
    "Požadavky na zlepšení: Je-li vyplněna Kategorie dovednosti 1, musí být k ní vybrána alespoň jedna konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0141":
    "Kompetence: Je-li vybrán jiný jazyk, je nutné uvést úroveň znalosti.",
  "hwr.rocni_hodnoceni.msg0142":
    "Profesní rozvoj: Je-li Mobilita = Ano, musí být vyplněno pole Region.",
  "hwr.rocni_hodnoceni.msg0143":
    "Pokud je u vzdělávací akce {row} Ano, je nutné vybrat vzdělávací akci, nebo doplnit popis.",
  "hwr.rocni_hodnoceni.msg0144":
    "Dovednost {row}: Pokud Vzdělávací akce = 'Ano', je nutno vybrat alespoň jednu konkrétní dovednost.",
  "hwr.rocni_hodnoceni.msg0145": "Hodnocení není podepsáno zaměstnancem.",
  "hwr.rocni_hodnoceni.msg0146": "Není vyplněno hodnocení.",
  "hwr.rocni_hodnoceni.msg0147": "Není vyplněn komentář zaměstnance.",
  "hwr.rocni_hodnoceni.msg0148": "Není vyplněn komentář hodnotitele.",
  "hwr.rocni_hodnoceni.msg0149":
    "Vyhodnocení kvalitativních ukazatelů - Cíl {row}: If definition is filled, fulfillment must be specified (0 ... 100).",
  "hwr.rocni_hodnoceni.msg0150":
    "Vyhodnocení individuálních cílů - Cíl {row}: Pokud je zadána definice, splnění musí být vyplněno (0 ... 100).",
  "hwr.rocni_hodnoceni.msg0151": "Vlastní hodnocení",
  "hwr.rocni_hodnoceni.msg0152": "Předchozí",
  "hwr.rocni_hodnoceni.msg0153": "Aktuální",
  "hwr.rocni_hodnoceni.msg0154": "Následující",
  "hwr.rocni_hodnoceni.msg0155": "Hodnotit podřízené",
  "hwr.rocni_hodnoceni.msg0156": "Hodnotit",
  "hwr.rocni_hodnoceni.msg0157":
    "Prohlédnout hodnocení podřízených zaměstnanců",
  "hwr.rocni_hodnoceni.msg0158": "Prohlédnout",
  "hwr.rocni_hodnoceni.msg0159": "Osobní číslo",
  "hwr.rocni_hodnoceni.msg0160": "Hodn. před.",
  "hwr.rocni_hodnoceni.msg0161": "Hodn. aktu.",
  "hwr.rocni_hodnoceni.msg0162": "Stav (akt)",
  "hwr.rocni_hodnoceni.msg0163": "Hodnocení příští",
  "hwr.rocni_hodnoceni.msg0164": "Uložit",
  "hwr.rocni_hodnoceni.msg0165": "Ukončeno zadání příslibu",
  "hwr.rocni_hodnoceni.msg0166": "Vyhodnoceno",
  "hwr.rocni_hodnoceni.msg0167": "Podepsat",
  "hwr.rocni_hodnoceni.msg0168": "Uložení proběhlo v pořádku",
  "hwr.rocni_hodnoceni.msg0169": "Podpis proběhl úspěšně",
  "hwr.rocni_hodnoceni.msg0170": "Stanovení cílů na aktuální rok",
  "hwr.rocni_hodnoceni.msg0171": "Stanovte 1 až 5 individuálních cílů Purpose",
  "hwr.rocni_hodnoceni.msg0172":
    "Hodnocení cílů 'Smysl naší činnosti - Veolia Purpose' - uplynulý rok",
  "hwr.rocni_hodnoceni.msg0173":
    "Pokud je některá z hodnot zadána, Definice a kategorie cíle jsou povinné",
  "hwr.rocni_hodnoceni.msg0174":
    "Pokud je vyplněno vyhodnocení, splnění musí být zadáno.",
  "hwr.rocni_hodnoceni.msg0175": "Komentář funkč. nadříz.",
  "hwr.rocni_hodnoceni.msg0176": "Podpis funkč. nadříz.",
  "hwr.rocni_hodnoceni.msg0177": "Stav aktuálního hodnocení",
  "hwr.rocni_hodnoceni.msg0178": "",
  "hwr.rocni_hodnoceni.msg0179": "",
  "hwr.rocni_hodnoceni.msg0180": "",
  "hwr.rocni_hodnoceni.msg0181": "",
  "hwr.rocni_hodnoceni.msg0182": "",
  "hwr.rocni_hodnoceni.msg0183": "",
  "hwr.rocni_hodnoceni.msg0184": "",
  "hwr.rocni_hodnoceni.msg0185": "",
  "hwr.rocni_hodnoceni.msg0186": "",
  "hwr.rocni_hodnoceni.msg0187": "",
  "hwr.rocni_hodnoceni.msg0188": "",
  "hwr.rocni_hodnoceni.msg0189": "",
  "hwr.rocni_hodnoceni.msg0190": "",
  "hwr.rocni_hodnoceni.msg0191": "",
  "hwr.rocni_hodnoceni.msg0192": "",
  "hwr.rocni_hodnoceni.msg0193": "",
  "hwr.rocni_hodnoceni.msg0194": "",
  "hwr.rocni_hodnoceni.msg0195": "",
  "hwr.rocni_hodnoceni.msg0196": "",
  "hwr.rocni_hodnoceni.msg0197": "",
  "hwr.rocni_hodnoceni.msg0198": "",
  "hwr.rocni_hodnoceni.msg0199": "",

  "hwr.rocni_hodnoceni.description": "Popis:",

  "hwr.echos_hodnoceni.title":
    "Hodnocení potenciálu ({year}): {name} ({region}",
  "hwr.echos_hodnoceni.title_short": "Hodnocení potenciálu:",
  "hwr.echos_hodnoceni.basic_data": "Základní údaje",
  "hwr.echos_hodnoceni.work_and_personal_data": "Pracovní a osobní údaje:",
  "hwr.echos_hodnoceni.personal_dev": "Osobní rozvoj",
  "hwr.echos_hodnoceni.results": "Výstupy",
  "hwr.echos_hodnoceni.results2": "Výstupy:",
  "hwr.echos_hodnoceni.region_list": "Seznam regionů",
  "hwr.echos_hodnoceni.eval_list": "Seznam hodnocení",
  "hwr.echos_hodnoceni.working_place": "Pracovní místo",
  "hwr.echos_hodnoceni.org4": "Útvar / Závod",
  "hwr.echos_hodnoceni.direct_leader": "Přímý vedoucí",
  "hwr.echos_hodnoceni.direct_subs_cnt": "Počet přímých podříz.",
  "hwr.echos_hodnoceni.retirement_5yr": "Starob.důchod do 5 let",
  "hwr.echos_hodnoceni.subs_cnt": "Počet podřízených",
  "hwr.echos_hodnoceni.years_cnt": "Počet let ve skupině",
  "hwr.echos_hodnoceni.age": "Věk",
  "hwr.echos_hodnoceni.en_level": "Úroveň znalosti AJ",
  "hwr.echos_hodnoceni.education_level": "Stupeň vzdělání",
  "hwr.echos_hodnoceni.fr_level": "Úroveň znalosti FJ",
  "hwr.echos_hodnoceni.salary": "Mzdové zařazení",
  "hwr.echos_hodnoceni.talent": "T",
  "hwr.echos_hodnoceni.supervisor": "Hodnotitel",
  "hwr.echos_hodnoceni.career": "Rozvoj kariéry zaměstnanec",
  "hwr.echos_hodnoceni.successor": "N",
  "hwr.echos_hodnoceni.mobility": "Mobilita",
  "hwr.echos_hodnoceni.mobility_cz": "Mobilita pouze v ČR",
  "hwr.echos_hodnoceni.key_worker": "KZ",
  "hwr.echos_hodnoceni.dev_spec": "Upřesnění rozvoje",
  "hwr.echos_hodnoceni.ggs_grade": "Klasifikace Veolia",
  "hwr.echos_hodnoceni.training_1": "Vzdělávací akce 1",
  "hwr.echos_hodnoceni.training_2": "Vzdělávací akce 2",
  "hwr.echos_hodnoceni.description": "Popis",
  "hwr.echos_hodnoceni.jobline": "Průběh činností - předchozí funkce",
  "hwr.echos_hodnoceni.education": "Průběh vzdělání",
  "hwr.echos_hodnoceni.planned_trainings":
    "Plánované akce dle plánu osobního rozvoje",
  "hwr.echos_hodnoceni.past_trainings":
    "Absolvované kurzy v posledních 3 letech",
  "hwr.echos_hodnoceni.higher_function": "Funkce s vyšší odpovědností",
  "hwr.echos_hodnoceni.next_position_description": "Příští pozice - popis",
  "hwr.echos_hodnoceni.next_training": "Další akce",
  "hwr.echos_hodnoceni.next_training_description": "Další akce - popis",
  "hwr.echos_hodnoceni.specialist": "Specialista",
  "hwr.echos_hodnoceni.faculty": "Dovednost",
  "hwr.echos_hodnoceni.expert_international": "Expert (mezinárodně)",
  "hwr.echos_hodnoceni.eval_summary": "Shrnutí hodnocení",
  "hwr.echos_hodnoceni.show_eval": "Zobrazit hodnoceni",
  "hwr.echos_hodnoceni.region": "Region",
  "hwr.echos_hodnoceni.full_name": "Jméno a příjmení",
  "hwr.echos_hodnoceni.personal_id": "Osobní číslo",
  "hwr.echos_hodnoceni.current_year": "Aktuální",
  "hwr.echos_hodnoceni.current_state": "Stav akt. hodnocení",
  "hwr.echos_hodnoceni.reference": "Reference",
  "hwr.echos_hodnoceni.function": "Funkce",
  "hwr.echos_hodnoceni.from": "Od",
  "hwr.echos_hodnoceni.to": "Do",
  "hwr.echos_hodnoceni.school": "Škola",
  "hwr.echos_hodnoceni.fakulty": "Fakulta",
  "hwr.echos_hodnoceni.field": "Obor",
  "hwr.echos_hodnoceni.degree": "Stupeň",
  "hwr.echos_hodnoceni.ended": "Ukončení",
  "hwr.echos_hodnoceni.action_name": "Akce",
  "hwr.echos_hodnoceni.deadline_plan": "Termín",
  "hwr.echos_hodnoceni.name": "Název",

  "hwr.personal_dev_plan.title": "Plán osobního rozvoje",
  "hwr.personal_dev_plan.personal_plan": "Vlastní plán",
  "hwr.personal_dev_plan.subs_plans": "Plány podřízených",
  "hwr.personal_dev_plan.new_entry": "Nová položka",
  "hwr.personal_dev_plan.cancel_new_entry": "Zrušit",
  "hwr.personal_dev_plan.submit_new_entry": "Uložit",
  "hwr.personal_dev_plan.organization": "Společnost",
  "hwr.personal_dev_plan.state": "Stav",
  "hwr.personal_dev_plan.plan_from": "Plán od",
  "hwr.personal_dev_plan.plan_to": "Plán do",
  "hwr.personal_dev_plan.superior": "Nadřízený",
  "hwr.personal_dev_plan.current_pos": "Současná pozice",
  "hwr.personal_dev_plan.current_level": "Úroveň pozice",
  "hwr.personal_dev_plan.planned_position": "Plánov.pozice (je - li známa)",
  "hwr.personal_dev_plan.planned_position_level": "Úroveň plánované pozice",
  "hwr.personal_dev_plan.planned_date": "Plánovaný termín",
  "hwr.personal_dev_plan.records_of_meetings": "Evidence uskutečněných setkání",
  "hwr.personal_dev_plan.meeting_1": "Setkání 1",
  "hwr.personal_dev_plan.meeting_2": "Setkání 2",
  "hwr.personal_dev_plan.meeting_3": "Setkání 3",
  "hwr.personal_dev_plan.meeting_4": "Setkání 4",
  "hwr.personal_dev_plan.note": "Poznámka",
  "hwr.personal_dev_plan.full_name": "Jméno a příjmení",
  "hwr.personal_dev_plan.personal_id": "Osobní číslo",
  "hwr.personal_dev_plan.plan_period": "Plánované období",
  "hwr.personal_dev_plan.goals": "Rozvojové cíle",
  "hwr.personal_dev_plan.actions": "Akce k naplnění cíle",
  "hwr.personal_dev_plan.benefit": "Očekávaný přínos",
  "hwr.personal_dev_plan.criteria": "Kritéria",
  "hwr.personal_dev_plan.deadline_plan": "Termín plán",
  "hwr.personal_dev_plan.performance_evaluation": "Hodnocení plnění",
  "hwr.personal_dev_plan.deadline_real": "Datum plnění",

  "hwr.adaptation_plan.title": "Adaptační plán",
  "hwr.adaptation_plan.personal_plan": "Vlastní plán",
  "hwr.adaptation_plan.subs_plans": "Plány podřízených",
  "hwr.adaptation_plan.type": "Typ",
  "hwr.adaptation_plan.state": "Stav",
  "hwr.adaptation_plan.position": "Pozice",
  "hwr.adaptation_plan.position_from": "Z pozice",
  "hwr.adaptation_plan.position_to": "Na pozici",
  "hwr.adaptation_plan.date_from": "Adaptace od",
  "hwr.adaptation_plan.date_to": "Adaptace do",
  "hwr.adaptation_plan.new_position_from": "Nová pozice od",
  "hwr.adaptation_plan.processed_by": "Zpracoval",
  "hwr.adaptation_plan.approved_by": "Schválil",
  "hwr.adaptation_plan.full_name": "Jméno a příjmení",
  "hwr.adaptation_plan.personal_id": "Osobní číslo",
  "hwr.adaptation_plan.view": "Prohlížet",

  "settings.user2notif.assign_notif_to_user":
    "Vyberte šablony, ze kterých chcete získávat notifikace",

  "webview.change_server": "Změnit server",
  "webview.clear_storage": "Vyčistit uložiště",

  "whereItem.relationType.textValue": "Text",
  "whereItem.relationType.numberValue": "Číslo",
  "whereItem.relationType.booleanValue": "Boolean",
  "whereItem.relationType.dateValue": "Datum",
  "whereItem.relationType.dateValueRange": "Rozmezí dat",
  "whereItem.relationType.dateValueDynamic": "Dynamické datum",
  "whereItem.relationType.like": "Podobná jako",
  "whereItem.relationType.isnull": "Null",
  "whereItem.relationType.notnull": "Not Null",
  "whereItem.relationType.selectValue": "Seznam hodnot",
  "whereItem.relationType.dynamicValue": "Hodnota z jiné šablony",
  "whereItem.relationType.ewaLogin": "Přihlašovací jméno FLOWIO",
  "whereItem.relationType.ewaUsername": "Uživatelské jméno FLOWIO",
  "whereItem.relationType.flowioLogin": "Moje přihlašovací jméno FLOWIO",
  "whereItem.relationType.flowioUsername": "Moje uživatelské jméno FLOWIO",
  "whereItem.relationType.hegLogin": "Přihlašovací jméno HeG",
  "whereItem.relationType.hegUsername": "Uživatelské jméno HeG",
  "whereItem.whereItemList": "Seznam podmínek",

  "WhereItemFilter.enter_filter_name": "Uložit filtr jako:",
  "WhereItemFilter.update_old": "(aktualizuje již existující filtr)",
  "WhereItemFilter.save_new": "(vytvoří nový filtr)",

  "WhereItemForm.selected": "Vybraný filtr",
  "WhereItemForm.new_filter": "Nový filtr",

  "WhereItemForm.boolean_options.true": "ano",
  "WhereItemForm.boolean_options.false": "ne",

  "searchType.text": "Text",
  "searchType.boolean": "Checkbox",
  "searchType.date": "Datum",
  "searchType.daterange": "Rozmezí dat",
  "searchType.dynamicDate": "Dynamický datum",
  "searchType.number": "Číslo",

  "FilterPicker.save_as_default": "Nastavit filtr jako výchozí",
  "FilterPicker.invalid_name": "Toto jméno pro filtr nelze použít",
  "FilterPicker.new_filter": "Nový filtr",

  "FilterPicker.static.empty": "PRÁZDNÝ FILTR",

  "actionsFilter.title": "Podmínky akcí",
  "actionsFilter.delete": "Mazání",
  "actionsFilter.create": "Vytváření",
  "actionsFilter.createInRow": "Vytváření v řádku",
  "actionsFilter.edit": "Úprava",
  "actionsFilter.copy": "Kopírování",
  "actionsFilter.copyInRow": "Kopírování v řádku",
  "actionsFilter.editInRow": "Úprava v řádku",
  "actionsFilter.export": "Export",
  "actionsFilter.visibility": "Zobrazení",
  "actionsFilter.prefill": "Předvyplnění",

  advanced_search: "Pokročilé vyhledávání",
  "advanced_search.run": "Spustit dotaz",
  "advanced_search.switch_to_advanced_mode": "Přepnout do pokročilého režimu",
  "advanced_search.switch_to_simple_mode": "Přepnout do jednoduchého režimu",
  "advanced_search.cannot_render_as_simple":
    "Vybraný filtr obsahuje pokročilou logiku, kterou není možné zobrazit v jednoduchém režimu",
  "advanced_search.switch_to_advanced_to_view":
    "Pro editaci filtru přepněte do pokročilého režimu",

  "dynamicDate.unit.second": "sekund",
  "dynamicDate.unit.minute": "minut",
  "dynamicDate.unit.hour": "hodin",
  "dynamicDate.unit.day": "dní",
  "dynamicDate.unit.week": "týdnů",
  "dynamicDate.unit.month": "měsíců",
  "dynamicDate.unit.year": "let",

  "dynamicDate.context.now": "Od teď",
  "dynamicDate.context.today": "Od dnes",
  "dynamicDate.context.unitStart": "Začátek období",
  "dynamicDate.context.unitEnd": "Konec období",

  "impersonation.impersonated_by": "impersonován uživatelem",
  "impersonation.impersonate": "impersonovat",
  "impersonation.cancel_impersonation": "ukončit impersonizaci",
  "impersonation.run_impersonation_function":
    "Jste impersonován na uživatele _NAME_. Chcete opravdu spustit funkci ",

  "calendar.events.title": "Události",
  "calendar.events.all_day_event": "Celodenní událost",
  "calendar.mobile_popup.delete": "Odstranit",
  "calendar.mobile_popup.edit": "Upravit",
  "calendar.mobile_popup.share": "Sdílet",
  "calendar.event_list.start": "Začátek",
  "calendar.event_list.end": "Konec",
  "calendar.event_list.category": "Kategorie",

  "input.text.maxLength": "Dosáhli jste maximálního počtu znaků ve slově",
  "input.text.invalidDecimal":
    "Neplatné desetinné číslo. Povolený počet desetinných míst je {max_decimal}",

  "input.date_range.invalid":
    "Zadáná hodnota je neplatná. Je nutné vyplnit všechny segmenty.",
  "input.date.placeholder": "DD.MM.RRRR",
  "input.date_time.placeholder": "DD.MM.RRRR HH:mm",

  "gate.options.and": "AND",
  "gate.options.or": "OR",
  "heg.only.options.login": "HeG Login",
  "heg.only.options.username": "HeG Username",
  "general.flowio_login": "FLOWIO Login",
  "general.flowio_username": "FLOWIO Username",

  "ssrs.parameters": "Parametry reportu",
  "ssrs.show_for_parameters": "Zobrazit pro zvolené parametry",
  "ssrs.parameter.visibility": "Viditelnost",
  "ssrs.parameter.editability": "Upravitelnost",
  "ssrs.parameter.date_format": "Zobrazit jako",
  "ssrs.parameter.type": "Typ",
  "ssrs.parameter.value": "Hodnota",

  "ssrs.parameter.type.static": "Statický",
  "ssrs.parameter.type.dynamic": "Dynamický",
  "ssrs.parameter.type.select": "Výběr z hodnot",

  "ssrs.parameter.dynamic.my_id": "Moje ID Helios",
  "ssrs.parameter.dynamic.this_day": "Tento den",
  "ssrs.parameter.dynamic.this_month": "Tento měsíc",
  "ssrs.parameter.dynamic.this_year": "Tento rok",
  "ssrs.parameter.dynamic.current_date": "Aktuální datum",

  "ssrs.parameter.date_format.date": "Datum",
  "ssrs.parameter.date_format.datetime": "Datum a čas",

  "ssrs.parameter.datasource.error":
    "Při získávání datových zdrojů k reportům došlo k chybě",
  "ssrs.parameters.empty":
    "Nejsou k dispozici žádné parametry.\nZkotrolujte, že máte vyplněný odkaz na report a nastavený datový zdroj.",
  "ssrs.parameter.datasource_mapping.error":
    "Při získávání nenamapovaných datových zdrojů došlo k chybě",

  ...pageTitleMessages,
  ...feedbackModalsMessages,
  ...toastMessages,
  ...hegMappingMessages,
  ...tableHeaderMessages,
  ...tBuilderValidationMessages,
} as const;

export default intlMessagesCs;
